<template>
<div style="height: 100%;overflow-y: auto;overflow-x: hidden">
    <el-input prefix-icon="el-icon-search" placeholder="输入搜索组织" v-model="filterText" clearable></el-input>
  <el-tree highlight-current default-expand-all :data="treeData" :props="defaultProps" disabled :current-node-key="currentId" node-key="showId"
           :filter-node-method="filterNode" ref="treeData"  @node-click="handleNodeClick">
    <div class="custom-tree-node" slot-scope="{ node, data }">
      <i class="el-icon-s-flag" v-if="data.org_type === 0"></i>
      <i class="el-icon-office-building" v-if="data.org_type === 1"></i>
      <i class="el-icon-menu" v-if="data.org_type === 2"></i>
      <span :title="data.name"> {{ data.name }}</span>
    </div>
  </el-tree>
</div>
</template>

<script>
import {queryorg} from '../../../api/organizer'
import {queryentity} from '../../../api/yanglaoyuan'

export default {
  name: 'treeOrganize',
  props: {
    treeObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orgTreeData: [],
      orgData: [],
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      currentId: '',
      expandedKeys: [],
      isFirst: [],
      orgIds: [],
      num: 0,
      isNo: false,
      entityArr: []
    }
  },
  created () {
    this.isNo = this.treeObj.isNo
    this.getOrgData()
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    handleNodeClick (node) {
      let obj = {type: 'node', node: node}
      this.$emit('getOrgArr', obj)
    },
    loadNode (node, resolve) {
      // console.log(123, node, node.data.entity_id)
      if (node.data.length === 0) {
        resolve(this.treeData)
        return
      }
      if (node.data.entity_id === '') {
        resolve(node.data.child)
      } else {
        if (node.data.orgid) {
          resolve([])
          return
        }
        let data = {
          oid: parseInt(node.data.entity_id)
        }
        let vm = this
        queryentity(data).then(res => {
          if (res.data.entity !== '' || res.data.entity !== null) {
            let arr = []
            for (let i = 0; i < res.data.entity.length; i++) {
              let obj = res.data.entity[i]
              obj.showId = vm.num
              obj.name = obj.entity_name
              vm.num++
              arr.push(obj)
            }
            resolve(arr)
          } else {
            resolve([])
          }
        }).catch(() => {})
      }
    },
    handleCheckChange () {
      this.currentPage = 1
      this.isFirst = this.$refs.treeData.getCheckedKeys()
    },
    // 左边树
    getOrgData () {
      queryorg().then(res => {
        this.orgData = res.data.org
        this.orgTreeData = this.clone(res.data.org)
        let obj = {type: 'orgArr', arr: res.data.org}
        this.$emit('getOrgArr', obj)
        // this.getOrgTree()
        this.getEntity()
      }).catch(() => {})
    },
    async getEntity () {
      let ids = []
      for (let i = 0; i < this.orgTreeData.length; i++) {
        if (this.orgTreeData[i].entity_id !== '' && this.orgTreeData[i].entity_id !== '0') {
          ids.push(parseInt(this.orgTreeData[i].id))
        }
      }
      for (let i = 0; i < ids.length; i++) {
        let data = {
          oid: parseInt(ids[i])
        }
        await queryentity(data).then(res => {
          this.entityArr = this.entityArr.concat(res.data.entity)
          let obj = {type: 'entityArr', arr: this.entityArr}
          this.$emit('getOrgArr', obj)
        }).catch(() => {})
      }
      this.getOrgTreeArr()
    },
    getOrgTreeArr () {
      // console.log(this.orgData, this.entityArr)
      for (let i = 0; i < this.orgData.length; i++) {
        if (this.orgData[i].entity_id !== '' && this.orgData[i].entity_id !== '0') {
          for (let j = 0; j < this.entityArr.length; j++) {
            if (parseInt(this.orgData[i].entity_id) === this.entityArr[j].id) {
              this.orgData[i].name = this.orgData[i].name + ' / ' + this.entityArr[j].entity_name
            }
          }
        }
      }
      // console.log(this.orgData)
      this.getOrgTree()
    },
    getOrgTree () {
      this.expandedKeys = []
      this.treeData = []
      for (let i = 0; i < this.orgData.length; i++) {
        if (this.orgData[i].orgpid === -1) {
          this.expandedKeys.push(this.orgData[i].id)
        }
      }
      // 所属组织
      let lastLevel = 100
      const arr = this.orgData
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.treeData.push(arr[i])
        }
      }
      for (let i = 0; i < this.treeData.length; i++) {
        const child = this.arrayToNode(arr, this.treeData[i].id)
        if (child.length !== 0) {
          this.treeData[i].child = child
        }
      }
      let obj = {type: 'org', arr: this.treeData}
      this.$emit('getOrgArr', obj)
      // console.log(999, this.treeData)
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/treeOrganize.vue